kombi.searchBar = () => {
  document.querySelectorAll(".location-search").forEach((item) => {
      const label = item.querySelector(".location-label");
      const value = item.querySelector(".location-value");
      const origin_term = item.querySelector(".origin-term");
      const input = item.querySelector(".location-input");
      const options = item.querySelector(".location-options");
      const terms_url = item.getAttribute("data-terms-url");
      const search_type = item.getAttribute("data-search-type") || null;
      const clear_location = item.querySelector(".clear-location");
      const toggle = item.querySelector('[data-bs-toggle="dropdown"]');
      const menu = item.querySelector(".dropdown-menu");
      const clearLabelReset =
        item.getAttribute("data-clear-label") ||
        (label && label.getAttribute("title")) ||
        "";
      const groups = {
        "city": "Cidades",
        "state": "Estados",
        "country": "Países",
        "neighborhood": "Bairros",
        "hotel": "Hotéis",
        "collection": "Coleções",
        "destination": "Destinos",
        "airport": "Aeroportos",
      }
      let waiting_set_interval = -1;

      if (!input || !options) {
        return;
      }

      const hintMinChars = "Digite 3 letras para começar a ver as opções";

      function setLabelText(text) {
        if (label) {
          label.textContent = text;
        }
      }

      function setHasResults(hasResults) {
        menu?.classList.toggle("has-results", hasResults);
      }

      function showMinCharsHint() {
        item.querySelectorAll(".search-text").forEach(function (element) {
          element.textContent = hintMinChars;
        });
        setHasResults(false);
        options.innerHTML = "";
        if (!item.querySelector(".search-text")) {
          const li = document.createElement("li");
          li.className = "dropdown-item-text text-black px-3 py-2 small";
          li.textContent = hintMinChars;
          options.append(li);
        }
      }

      function getOppositeSelectedTerm() {
        const form = input.closest("form") || document;
        const selectedValue = search_type === "origin"
          ? form.querySelector(
              '.location-search[data-search-type="destination"] input[name="location"]'
            )?.value
          : form.querySelector(
              '.location-search[data-search-type="origin"] input[name="origin_airport_term"]'
            )?.value;
        const selectedParts = (selectedValue || "").split("|");

        if (!selectedParts[0] || !selectedParts[1]) {
          return "";
        }

        return `${selectedParts[0]}|${selectedParts[1]}`;
      }

      input.addEventListener("keypress", function(event) {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      });

      if (toggle && toggle.contains(input) && toggle !== input) {
        input.addEventListener("click", (e) => {
          e.stopPropagation();
          if (!menu?.classList.contains("show")) {
            bootstrap.Dropdown.getOrCreateInstance(toggle).show();
          }
        });

        input.addEventListener("focus", () => {
          if (!menu?.classList.contains("show")) {
            bootstrap.Dropdown.getOrCreateInstance(toggle).show();
          }
        });
      }

      item.addEventListener("shown.bs.dropdown", () => {
        if (typeof push_to_datalayer === "function") {
          const eventName =
            search_type === "origin"
              ? "search_interact_origin"
              : "search_interact_destination";
          push_to_datalayer({ event: eventName });
        }
        input.focus();
        input.select();
        if (!terms_url) {
          return;
        }
        if (input.value.length < 3) {
          showMinCharsHint();
        } else {
          input.dispatchEvent(new Event("input", { bubbles: true }));
        }
      });

      clear_location?.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(waiting_set_interval);
        value.value = "";
        const originLabelClear = item.querySelector(
          'input[name="origin_airport_label"]'
        );
        if (originLabelClear) {
          originLabelClear.value = "";
          origin_term.value = ""
        }
        setLabelText(clearLabelReset);
        input.value = "";
        if (terms_url) {
          showMinCharsHint();
        } else {
          options.innerHTML = "";
          setHasResults(false);
        }
        kombi.updateCalendar(null);
      });

      input.addEventListener("input", () => {
          if (!terms_url) return;
          if (input.value.length >= 3){
            clearTimeout(waiting_set_interval);
            waiting_set_interval = setTimeout(() => {
              const fetchUrl = search_type
                ? `${ terms_url }?q=${encodeURIComponent(input.value)}&search_type=${search_type}&selected_search_term=${getOppositeSelectedTerm()}`
                : `${ terms_url }?q=${encodeURIComponent(input.value)}`;
              fetch(fetchUrl)
              .then(function(response) {
                  return response.json();
              }).then(function(data) {
                options.innerHTML = "";

                if (Object.keys(data).length === 0) {
                  setHasResults(false);
                  item.querySelectorAll(".search-text").forEach(function(element) {
                    element.textContent = "Não encontramos um resultado para sua busca";
                  });
                  if (!item.querySelector(".search-text")) {
                    const li = document.createElement("li");
                    li.className = "dropdown-item-text text-black px-3 py-2 small";
                    li.textContent = "Não encontramos um resultado para sua busca";
                    options.append(li);
                  }
                } else {
                  setHasResults(true);
                  item.querySelectorAll(".search-text").forEach(function(element) {
                    element.textContent = "Resultados da busca";
                  });

                  let isFirstGroup = true;
                  for (const [key, val] of Object.entries(data)) {
                    let group = document.createElement("li")
                    let header = document.createElement("div");
                    header.className = isFirstGroup
                      ? "dropdown-header bg-secondary-subtle text-black rounded-2"
                      : "dropdown-header border-top bg-secondary-subtle text-black";
                    header.textContent = groups[key] || key;
                    group.append(header);
                    isFirstGroup = false;
                    options.append(group)

                    val.map(function(option) {
                      let li = document.createElement("li")
                      let anchor = document.createElement("a");
                      anchor.href = "#";
                      anchor.className = "dropdown-item text-wrap";
                      anchor.textContent = option.label;
                      li.append(anchor);
                      li.addEventListener("click", (e) => {
                          e.preventDefault();
                          kombi.updateCalendar(null)
                          let storedValue = `${ option.type }|${ option.pk }|${ option.label }`;
                          if (
                            search_type === "origin" &&
                            option.type === "airport"
                          ) {
                            const iataMatch = option.label.match(
                              /\(([A-Z]{3})\)\s*$/
                            );
                            if (iataMatch) {
                              storedValue = iataMatch[1];
                            }
                          }
                          value.value = storedValue;

                          if (search_type === "origin") {
                             const originStoredValue = `${ option.type }|${ option.pk }|${ option.label }`;
                             origin_term.value = originStoredValue;
                          }

                          const originLabelInput = item.querySelector(
                            'input[name="origin_airport_label"]'
                          );
                          if (originLabelInput) {
                            originLabelInput.value = option.label;
                          }
                          setLabelText(option.label);
                          input.value = option.label;
                          if (option.type === "hotel") {
                              kombi.updateCalendar(option.pk);
                          }
                          const dd = bootstrap.Dropdown.getInstance(toggle);
                          if (dd) {
                            dd.hide();
                          }
                      })
                      options.append(li)
                    })
                  }
                }
              });
            }, 300);
          } else {
            showMinCharsHint();
          }
      })
  })
}

kombi.showSearch = () => {
  const searchBar = document.querySelector(".d-sm-block .nav-search");
  if (!searchBar) {
    window.location.href = "/#showSearch";
    return
  }
  if (window.matchMedia("(min-width: 992px)").matches) {
    kombi.highlightElement();
  } else {
    const modalElement = document.getElementById("SearchForm");
    let modalInstance = bootstrap.Modal.getInstance(modalElement);
    if (!modalInstance) {
        modalInstance = new bootstrap.Modal(modalElement);
    }
    modalInstance.show();
  }
};

kombi.checkSearchHash = () => {
  const hash = window.location.hash;

  if (hash === "#showSearch") {
    history.replaceState(null, null, ' ');
    kombi.showSearch();
  }
};
